// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__vEAoR","cell":"ColumnAccessor_cell__18oUZ","firstCellAccent":"ColumnAccessor_firstCellAccent__10I1a"};